// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3n5ht","col":"styles_col__2JX6q"};